<template>
  <header>
    <h2>Recargas y gastos</h2>

    <a-button type="link" @click="handleUpdate" :disabled="isUpdating"> Actualizar datos recientes </a-button>
  </header>

  <section class="billing">
    <BalanceCard type="calls" ref="balanceCardRef" />

    <BillingTabs
      :type="ProductType.Voice"
      :isInfinite="isInfinite"
      ref="billingTabsRef"
      class="billing__tabs"
    />

    <BalanceRechargeCard
      :minVal="minRechargeAmount"
      :isInfinite="isInfinite"
      :type="ProductType.Voice"
      ref="rechargeRef"
      :slots="slots"
      class="billing__payment"
      @update="handleUpdate"
    />
  </section>
</template>

<script setup lang="ts">
import { computed, ref, onMounted } from "vue";

import { BillingType, ProductType } from "@/@types/settings/billing";

import BalanceCard from "../cards/BalanceCard.vue";
import BillingTabs from "../tabs/BillingTabs.vue";
import BalanceRechargeCard from "@/app/settings/components/cards/BalanceRechargeCard.vue";
import SlotManager from "@/app/settings/services/slots/SlotManager";
import { ISlots } from "@/@types/settings/slots";

const manager = new SlotManager();

const slots = ref<ISlots>();
const balanceCardRef = ref<InstanceType<typeof BalanceCard>>();
const billingTabsRef = ref();
const rechargeRef = ref();
const isUpdating = ref(false);

const handleUpdate = async () => {
  if (isUpdating.value) return;

  isUpdating.value = true;

  try {
    await Promise.all([
      balanceCardRef.value?.fetchBalance(),
      billingTabsRef.value?.handleUpdate(),
    ]);
  } finally {
    isUpdating.value = false;
  }
};

const isInfinite = computed(() => balanceCardRef.value?.billingType === BillingType.Postpaid);

const minRechargeAmount = computed(() => {
  const negativeAmount = balanceCardRef.value?.balance ?? 0;

  return negativeAmount < 0 ? -1 * negativeAmount + 5 : 5;
});

const fetchSlots = async () => {
  const response = await manager.getInfoSlots();
  console.log(response, "responserechargetemplate");
  slots.value = response;
};

onMounted(() => {
  fetchSlots();
});
</script>

<style lang="sass" scoped>
header
  display: flex
  align-items: baseline
  margin-bottom: 12px

h2
  font-size: 20px
  font-weight: 600
  line-height: 24px
  margin: 0

.billing
  display: grid
  grid-template-columns: repeat(2, minmax(400px, 1fr)) minmax(250px, 450px)
  grid-template-rows: 95px minmax(0, 1fr)
  gap: 8px 20px
  height: calc(100% - 44px)

  &__tabs
    grid-column: 1 / 3
    grid-row: 2 / 3

  &__payment
    grid-column: 3
    grid-row: 1 / 3
</style>
